import formatAmount from 'shared/helpers/formatAmount'
import {
  calculateLineTotalExcl,
  calculateLineTotalIncl,
} from 'features/invoices/helpers/invoiceCalculations'
import { InvoiceLine } from 'types'
import { TableProps } from 'antd'
import { EMPTY_CELL_VALUE } from 'constants/display'

export const tableColumns: TableProps<InvoiceLine>['columns'] = [
  {
    key: 'label',
    title: 'Item',
    dataIndex: 'label',
  },
  {
    key: 'quantity',
    title: 'Quantity',
    dataIndex: 'quantity',
  },
  {
    key: 'unit',
    title: 'Unit',
    dataIndex: 'unit',
  },
  {
    key: 'price',
    title: 'Unit Price (Excl. Tax)',
    dataIndex: 'product',
    render: (product) =>
      product ? formatAmount(Number(product.unit_price_without_tax)) : EMPTY_CELL_VALUE,
  },
  {
    key: 'vat_rate',
    title: 'VAT',
    dataIndex: 'vat_rate',
    render: (value) => `${value}%`,
  },
  {
    key: 'tax',
    title: 'VAT Amount',
    dataIndex: 'tax',
    render: (value) => formatAmount(Number(value)),
  },
  {
    key: 'amount_excl_tax',
    title: 'Total (Excl. Tax)',
    dataIndex: 'product',
    render: (_, line: InvoiceLine) => {
      const amount = calculateLineTotalExcl(line.product, line.quantity)
      return amount !== null ? formatAmount(amount) : EMPTY_CELL_VALUE
    },
  },
  {
    key: 'amount_incl_tax',
    title: 'Total (Incl. Tax)',
    dataIndex: 'product',
    render: (_, line: InvoiceLine) => {
      const amount = calculateLineTotalIncl(line.product, line.quantity)
      return amount !== null ? formatAmount(amount) : EMPTY_CELL_VALUE
    },
  },
]
